// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__X0EpD","point":"classes_point__1mFYi","on":"classes_on__anvCx","off":"classes_off__3E6Pu"};